import $ from 'jquery';

export default class Rules {
    /**
     * Constructor.
     *
     * @return {Void}
     */
    constructor() {
        this._$ui = {};
        var that = this;

        // Wait for DOM load and init all.
        $(() => {
            that._$ui.createRuleForm = $('#createRuleForm');
            that.rulesEngineModal = null;
            $('body')
                .on('click', '.opd-create-new-rule-btn', that.addNewRule.bind(that))
                .on('click', '.opd-save-btn', that.formSubmit.bind(that))
                .on('click', '.opd-delete-rule', that.deleteRule.bind(that))
                .on('click', '.opd-edit-rule', that.editRule.bind(that))
        })
    }

    /**
     * Opens dialog when click on "Use This Template" Button
     *
     * @param e
     * @return {Void}
     */
    addNewRule(e) {
        e.preventDefault();

        let _this = this;
        let $target = $(e.currentTarget);
        let dialogOptions = window.OP3General.dialogOptions;

        _this.rulesEngineModal = $.dialog(Object.assign(dialogOptions, {
            theme: 'optimizepress',
            title: 'Create New Rule',
            content: () => {
                let options = {
                    adminUrl: $target.attr('href'),
                };

                return _this.getAddNewRuleForm(options);
            },
        }));
    }

    /**
     * Opens dialog when click on "Use This Template" Button
     *
     * @param e
     * @return {Void}
     */
    editRule(e) {
        e.preventDefault();

        let _this = this;
        let $target = $(e.currentTarget);
        let dialogOptions = window.OP3General.dialogOptions;
        let ruleId = $(e.currentTarget).data('rule-id');

        $.ajax({
            url: OpsScriptData.opd_api_url + 'rules-engine',
            data: {
                ruleId: ruleId,
                _wpnonce: window.OpsScriptData.nonce
            },
            method: 'get',
            dataType: 'json',
        }).done(function(response) {
            _this.rulesEngineModal = $.dialog(Object.assign(dialogOptions, {
                theme: 'optimizepress',
                title: 'Edit Rule',
                content: () => {
                    let options = {
                        adminUrl: $target.attr('href'),
                        ruleId: ruleId,
                        action: 'editRule',
                        submitText: 'Save Rule',
                        ruleData: response.data[0]
                    };

                    return _this.getAddNewRuleForm(options);
                },
            }));
        }).fail(function(response) {
            window.OPDashboard.Helpers.notify(response.responseJSON.message, "error");
        });
    }

    /**
     * Form HTML that is submitted upon creating new Rule
     *
     *
     * @param {Array} options
     * @return {String}
     */
    getAddNewRuleForm(options) {
        const defaultOptions = {
            action: 'createRule',
            ruleId: null,
            ruleData: null,
            adminUrl: null,
            nonceValue: null,
            templateUid: null,
            fieldTitle: 'Rule Name',
            fieldPlaceholder: 'Enter Rule Name',
            submitText: 'Create Rule',
            submittingText: 'Saving ...',
            triggersTitle: 'Trigger Event',
            requestTypes: [
                {'id': 'post', 'title': 'POST'},
                {'id': 'json', 'title': 'JSON'},
            ],
            triggers: [
                {'id': 'all', 'title': 'All Events'},
                {'id': 'optin.successful', 'title': 'New Subscriber (subscriber added from optin form)'},
                {'id': 'contact.submitted', 'title': 'Contact Form Submitted'},
                {'id': 'registration.successful', 'title': 'Sign Up Form Submitted'},
                {'id': 'payment.success', 'title': '(Checkouts) Payment Successful'},
                {'id': 'payment.refund', 'title': '(Checkouts) Payment Refunded'},
                {'id': 'subscription.created', 'title': '(Checkouts) Subscription Created'},
                {'id': 'subscription.cancelled', 'title': '(Checkouts) Subscription Cancelled'},
                {'id': 'subscription.payment.success', 'title': '(Checkouts) Subscription Payment Successful'},
                {'id': 'subscription.payment.failed', 'title': '(Checkouts) Subscription Payment Failed'},
                {'id': 'subscription.schedule.completed', 'title': '(Checkouts) Payment Plan Completed'}
            ],
        };

        options = {...defaultOptions, ...options};

        return `
            <div class="ops-container-fluid">
                <form class="ops-form ops-form-single-submit" id="createRuleForm" method="post" action="${options.adminUrl}">
                    <input type="hidden" name="action" value="${options.action}">
                    <input type="hidden" name="ruleId" value="${options.ruleId ? options.ruleId : ''}">
                    <div class="ops-row">
                        <div class="ops-col-12">
                            <div class="ops-form-group">
                                <label for="ruleName">${options.fieldTitle}</label>
                                <input id="ruleName" type="text" name="name" value="${options.ruleData ? options.ruleData.name : ''}" placeholder="${options.fieldPlaceholder}" class="ops-form-control" required>
                            </div>
                        </div>
                        <div class="ops-col-12">
                            <div class="ops-form-group">
                                <label for="trigger">${options.triggersTitle}</label>
                                <select id="trigger" "name="trigger" class="ops-form-control" required style="max-width: 100%;font-size: 15px;line-height:23px;width:100% !important">
                                    ${options.triggers.map((item, i) => `
                                        <option value="${item.id}" ${(options.ruleData && options.ruleData.trigger_type === item.id) ? 'selected' : ''}>${item.title}</option>
                                    `.trim()).join('')}
                                </select>
                            </div>
                        </div>
                        <div class="ops-col-12">
                            <div class="ops-form-group">
                                <label for="opd-action">Action</label>
                                <select id="type" name="type" class="ops-form-control" required style="max-width: 100%;font-size: 15px;line-height:23px;width:100% !important">
                                    <option value="webhook">Webhook</option>
                                </select>
                            </div>
                        </div>
                        <div class="ops-col-12">
                            <div class="ops-form-group">
                                <label for="opd-action">Request Type</label>
                                <select id="requestType" name="request_type" class="ops-form-control" required style="max-width: 100%;font-size: 15px;line-height:23px;width:100% !important">
                                    ${options.requestTypes.map((item, i) => `
                                        <option value="${item.id}" ${(options.ruleData && options.ruleData.request_type === item.id) ? 'selected' : ''}>${item.title}</option>
                                    `.trim()).join('')}
                                </select>
                            </div>
                        </div>
                        <div class="ops-col-12">
                            <div class="ops-form-group">
                                <label for="webhookUrl">Webhook URL</label>
                                <input id="webhookUrl" type="url" name="webhookUrl" value="${options.ruleData ? options.ruleData.webhook_url : ''}" placeholder="https://example.com" class="ops-form-control" required>
                            </div>
                        </div>
                    </div>
                    <div class="opui-form-actions">
                        <a class="opui-btn opui-btn-primary opd-save-btn">
                            <span class="opui-spinner opui-spinner-border opui-text-light opui-mr-2"></span>
                            <span class="opui-btn-saving-label">${options.submittingText}</span>
                            <span class="opui-btn-label">Save Rule</span>
                        </a>
                    </div>
                </form>
            </div>`;
    }

    /**
     * Submit form
     */
    formSubmit(e) {
        e.preventDefault();

        let $form = $(e.currentTarget.closest('form'));

        // trigger browser validation
        if (! $form[0].reportValidity())
            return false;

        let action = $form.find('[name="action"]').val();
        let name = $form.find('#ruleName').val();
        let trigger = $form.find('#trigger :selected').text();
        let triggerType = $form.find('#trigger :selected').val();
        let type = $form.find('#type :selected').val();
        let requestType = $form.find('#requestType :selected').val();
        let webhook = $form.find('#webhookUrl').val();
        let ruleId = null;

        if (action === "editRule") {
            ruleId = $form.find('[name="ruleId"]').val();
        }

        // disable button after click
        let $button = $(e.currentTarget);
        $button.find(".opui-spinner").attr("style", "display: inline-block !important");
        $button.find(".opui-btn-saving-label").attr("style", "display: inline-block !important");
        $button.find(".opui-btn-label").attr("style", "display: none !important");
        $button.attr("disabled", "disabled");
        $button.css('opacity', '0.4');

        $.ajax({
            url: OpsScriptData.opd_api_url + 'rules-engine',
            data: {
                action: action,
                ruleId: ruleId,
                name: name,
                trigger: trigger,
                triggerType: triggerType,
                type: type,
                requestType: requestType,
                webhook: webhook,
                _wpnonce: window.OpsScriptData.nonce
            },
            method: 'post',
            dataType: 'json',
        }).done(function(response) {
            window.OPDashboard.Helpers.notify(response.data.message, "success");

            if ($form.data('redirectUrl')) {
                window.location.replace($form.data('redirectUrl'));
            } else {
                location.reload();
            }
        }).fail(function(response) {
            window.OPDashboard.Helpers.notify(response.responseJSON.message, "error");
        });

        return false;
    }

    /**
     * Delete Rule REST
     *
     * @param e
     * @return {Void}
     */
    deleteRule(e) {
        e.preventDefault();

        let ruleId = $(e.currentTarget).data('rule-id');
        let dialogOptions = window.OP3General.dialogOptions;

        window.OP3General.confirm(
            Object.assign(dialogOptions, {
                theme: 'optimizepress',
                closeIcon: true,
                title: 'Delete Rule',
                content: () => {
                    return '<div class="ops-container-fluid"><p style="color: #000; font-size: 1.6rem;">Are you sure you want to delete a rule?</p></div>'
                },
                buttons: {
                    confirm: {
                        text: "Delete",
                        btnClass: 'opui-btn opui-btn-danger opui-float-right',
                        action: function() {
                            this.$$confirm.prop('disabled', true);
                            this.$$confirm.html('<span style="display: inline-block !important" class="opui-spinner opui-spinner-border opui-text-light opui-mr-2"></span> Deleting ...');

                            $.ajax({
                                url: OpsScriptData.opd_api_url + 'rules-engine/delete',
                                data: {
                                    ruleId: ruleId,
                                    _wpnonce: window.OpsScriptData.nonce
                                },
                                method: 'post',
                                dataType: 'json',
                            }).done(function(response) {
                                window.OPDashboard.Helpers.notify(response.data.message, "success");
                                location.reload();
                            }).fail(function(response) {
                                window.OPDashboard.Helpers.notify(response.responseJSON.message, "error");
                            });
                            return false;
                        }
                    }
                }
            })
        );
    }
}